import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { Mediaclip } from '../../../interfaces/mediaclip';
import { BbReactComponent } from 'app/components/shared/bb-react/bb-react.component';

@Component({
	selector: 'vast-details-react',
	templateUrl: './vast-details-react.component.html'
})

export class VastDetailsReactComponent implements OnInit {
	@Input() creative: Mediaclip;
	@Input() form: NgForm;

	@ViewChild(BbReactComponent) reactComponent: BbReactComponent;

	entity: Mediaclip;

	constructor() {
	}

	ngOnInit() {
		this.entity = this.creative;
	}

	// cancel from bb action bar
	cancel(): void {
		this.reactComponent.cancel();
	}
}
